/** Name of the consent cookie, shared by the SPA, IdentityServer and the legacy layout (SB-17045). */
export const CONSENT_COOKIE_NAME = 'cc_cookie';

/** The cookieconsent category that gates Google Analytics, Microsoft Clarity and Pendo. */
export const ANALYTICS_CATEGORY = 'analytics';

/**
 * Multi-label public suffixes that SchoolsBuddy hosts live under. A cookie cannot be set on a public suffix,
 * so hosts under one of these get a host-only consent cookie. Extend this list if a deployment moves under
 * another multi-label public suffix.
 *
 * IdentityServer has a copy of this logic in SchoolsBuddy.IdentityServer/wwwroot/js/cookie-consent.js:
 * keep the two in step.
 */
const MULTI_LABEL_PUBLIC_SUFFIXES = ['azurewebsites.net', 'azureedge.net'];

const IPV4 = /^\d{1,3}(\.\d{1,3}){3}$/;

/**
 * Works out the domain the consent cookie is written on, so that the apps on one registrable domain share a
 * single consent choice.
 *
 * @param hostname The page's `location.hostname`.
 * @returns The registrable domain (the last two labels), or `null` when the cookie must be host-only:
 * localhost, IP addresses, single-label hosts and hosts under a multi-label public suffix.
 */
export function getConsentCookieDomain(hostname: string): string | null {
  const host = (hostname || '').toLowerCase();

  if (host === 'localhost' || host.endsWith('.localhost') || !host.includes('.') || host.includes(':')) {
    return null;
  }

  if (IPV4.test(host)) {
    return null;
  }

  if (MULTI_LABEL_PUBLIC_SUFFIXES.some(suffix => host === suffix || host.endsWith('.' + suffix))) {
    return null;
  }

  return host.split('.').slice(-2).join('.');
}
